import type { ImpactGroup } from '@locus-taxy/entity-detail';
import { BASE_CONDITION_PARAM } from './baseConditionParam';
import { buildClientPrefixedPath } from './url';

/**
 * Path to the entity grid narrowed to one impact-preview group (DP-8309): the
 * group's entity, filtered by the group's condition through the grid page's
 * generic `p.baseCondition` param. Returns null for a group that names no
 * entity or carries no condition, so the caller does not navigate.
 */
export function buildDependentGridPath(
  group: Partial<Pick<ImpactGroup, 'targetEntity' | 'condition'>>,
  clientId: string
): string | null {
  if (!group.targetEntity || !group.condition) {
    return null;
  }
  const condition = encodeURIComponent(JSON.stringify(group.condition));
  return buildClientPrefixedPath(
    `/entities/${group.targetEntity}?${BASE_CONDITION_PARAM}=${condition}`,
    clientId
  );
}
